export class MetodoPagoModel {
    idtipo_pago: number;
    descripcion: string;
    importe: string;
    checked: boolean;
    visible: boolean;
    img: string;
    info: string;
}
